module.exports = __webpack_public_path__ + "img/undraw_version_control_9bpv.bd6fb7a3.svg";